<script>
import { useField } from '@phoenix/composables/field';
import { defineAsyncComponent } from 'vue';
import fieldMixin from '@maison/mixins/fieldMixin';
const CheckboxField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxField.vue'));
const CheckboxCardField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxCardField.vue'));
const CheckboxThumbnailField = defineAsyncComponent(
  () => import('@maison/components/form/fields/CheckboxThumbnailField.vue'),
);

export default {
  mixins: [fieldMixin],

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxComponent() {
      switch (this.type) {
        case 'card':
          return CheckboxCardField;
        case 'thumbnail':
          return CheckboxThumbnailField;
        default:
          return CheckboxField;
      }
    },
  },
};
</script>

<template>
  <component
    :is="checkboxComponent"
    v-for="option in field.options"
    :key="option.id"
    v-model="value"
    :parent-id="field.id"
    :attrs="option"
    :should-validate="false"
  />
</template>
